<mat-calendar
    [selected]="selectedDate"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [dateClass]="dateClass()"
    [dateFilter]="myDateFilter"
    (selectedChange)="onSelect($event)"
    (monthSelected)="handleMonthSelected($event)">
</mat-calendar>